import { generateSiteLink } from './generator'

export const siteLink = generateSiteLink()
